import React from 'react';
import { TranslationKeys } from '../../core/constants/translationKeys';

function AboutHashButton({ handleClick, t }) {
  return (
    <div className='cpt-about-row'>
      <button className='cpt-about-btn' onClick={handleClick}>
        <span>?</span>
        <span>{t(TranslationKeys.AboutHash)}</span>
      </button>
    </div>
  );
}

export default AboutHashButton;
